<div class="wrapper">
  <h1>Quick Start Guide</h1>

  <div class="step">
    <h2>Getting the Plugin</h2>
    <p>
      IntelliJ-RON supports any of <a href="https://www.jetbrains.com/">JetBrain's IDEs</a>.
      If you don't know where to start, we'd recommend IntelliJ Idea Ultimate or Clion.
    </p>
    <p>
      IntelliJ-RON is dependent upon the IntelliJ Rust plugin. To install it, follow their
      <a href="https://intellij-rust.github.io/docs/quick-start.html">quickstart guide</a>.
    </p>
    <p>
      To install the RON plugin, go to <code>Settings / Preferences -> Plugins -> Marketplace</code> and search for
      "RON".
      Install the plugin titled "RON (Rusty Object Notation)" to begin.
    </p>
  </div>


  <div class="step">
    <h2>Using the Plugin</h2>
    <p>As RON is built to represent Rust types, open or create a new Rust project. Then, create a new RON file.</p>
    <img src="/intellij-ron-plugin/assets/new-ron-file.png" class="newFile" alt="">
    <p>See <a routerLink="/features">Features</a> to learn how to import a Rust type.</p>
  </div>
</div>
